import { addFormSubmitSagaTo } from 'redux-form-submit-saga';

import { reducersMap } from './rootReducer';
import rootSaga from './rootSaga';
import createConfigureStore from './createConfigureStore';

export default createConfigureStore(reducersMap, rootSaga, addFormSubmitSagaTo);
